export default __webpack_public_path__ + "static/media/DetailEssayImg.33d8d5f5.png";